module.exports = __webpack_public_path__ + "img/apple-iphone-11-pro.085b1d99.png";